import {SALES_PERSON_RESULT_URL_PATH} from 'components/quickSearch/constants/quickSearch';
import {LocationDescriptor} from 'history';

/**
 * checks if url is not valid for Link component
 * @param {string} link - link
 * @returns {boolean} - is url broken
 */
export const isUrlBroken = (link: string) => {
    return !link.startsWith('/') && !link.startsWith('http');
};

/**
 * Creates url for Link component
 * @param {string} link - search result item link
 * @returns {LocationDescriptor} url - Link`s component "to" prop value
 */
export const getLinkProps = (link: string): LocationDescriptor => {
    //  only if celebros or algolia did not found the one the user was looking for
    if (!link.includes(SALES_PERSON_RESULT_URL_PATH)) {
        // because server gives link for product using different format
        if (isUrlBroken(link)) {
            return `/${link}`;
        }
        return link;
    }

    return {
        pathname: link.replace(/\?.*|#.*/, ''), // leaves only scheme,userInfo,host,port,path parts of given link removes ?query and #fragment parts
        search: (() => {
            const res = /(\?[^#]*)/.exec(link);
            if (res) {
                return res[0];
            }
            return '';
        })(), // removes scheme,userInfo,host,port,path,fragment parts of given link leaves only ?query part
        state: {
            page: 'search',
            params: {
                id: 0, // without this dynamic router will crashes
            },
        },
    };
};

/**
 * getSearchResultPageUrl
 * @param {String} query - query
 * @returns {String} - url
 */
export const getSearchResultPageUrl = (query: string) => `/salesperson/result/?q=${query}`;

/**
 * getSearchResultName
 * @param {String} name - name of the result element
 * @param {string} query - user query
 * @returns {String} - name of the result element
 */
export const getSearchResultName = (name: string, query: string) => {
    if (query.length < 2) {
        return name;
    }

    const regex = new RegExp(query, 'gi');
    return name.replace(regex, '<b>$&</b>');
};
